import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "technology-main"
  }, [_c("h3", {
    staticClass: "puhui-M"
  }, [_vm._v("技术能力")]), _c("p", {
    staticClass: "module-desc"
  }, [_vm._v("先进、全面和强大的人工智能能力")]), _c("div", {
    staticClass: "module-img"
  }, [_c("ul", _vm._l(_vm.technologyList, function (item, index) {
    return _c("li", {
      key: index,
      staticClass: "title"
    }, [_c("h4", [_c("div", [_vm._v(_vm._s(item.title))])])]);
  }), 0), _c("img", {
    attrs: {
      src: require("@/assets/images/homepage/ai-center.png"),
      alt: "ai-center"
    }
  })]), _c("div", {
    staticClass: "list"
  }, _vm._l(_vm.AiCardList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "list-item",
      on: {
        click: function ($event) {
          return _vm.$router.push(item.path);
        }
      }
    }, [_c("span", {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _c("span", {
      staticClass: "img"
    })]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };